export default {
  'pt-BR': '+55',
};



// WEBPACK FOOTER //
// ../utils/i18n/country-code.js